import {
  API_ACTION,
  API_TEAM_PROJECT,
  API_TEAM_PROJECT_CURRENT_EMPLOYEE,
  API_TEAM_PROJECT_EMPLOYEE,
  API_TEAM_PROJECT_EMPLOYEE_HISTORY,
  API_TEAM_PROJECT_EMPLOYEE_PERIOD,
} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getProjectByEmployeeId = async (employeeId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_TEAM_PROJECT_EMPLOYEE}/${employeeId}`,
    });
    return res.data.data;
  } catch (error) {
    console.error('teamProjectApi getProjectByEmployeeId error:', error.message);
    return null;
  }
};

/**
 * @param {number} employeeId 
 * @param {number} periodId 
 * @returns {Promise<Array>}
 */
const getEmployeeProjectsByPeriod = async (employeeId, periodId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_TEAM_PROJECT_EMPLOYEE_PERIOD.replace('{EMPLOYEE_ID}', employeeId).replace('{PERIOD_ID}', periodId),
    });
    return res.data.data;
  } catch (error) {
    console.error('teamProjectApi getEmployeeProjectsByPeriod error:', error.message);
    return [];
  }
};

const getCurrentTeamMembers = async (projectId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_TEAM_PROJECT_CURRENT_EMPLOYEE.replace("{PROJECT_ID}", projectId)
    });
    return res.data?.data || [];
  } catch (error) {
    console.error('teamProjectApi getCurrentTeamMembers error:', error.message);
    return null;
  }
};

const getTeamProjectMembersHistory = async (projectId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_TEAM_PROJECT_EMPLOYEE_HISTORY.replace("{PROJECT_ID}", projectId)
    });
    return res.data?.data || [];
  } catch (error) {
    console.error('', error.message)
  }
}

const createTeamAssignments = async (assignments) => {
  try {
    const response = await callAPI({
      method: RestApiMethod.POST,
      url: API_TEAM_PROJECT + API_ACTION.CREATE + API_ACTION.BATCH,
      data: assignments
    });
    return response.data; 
  } catch (error) {
    console.error('teamProjectApi createTeamAssignments error:', error.message);
  }
};

const updateTeamRoles = async (roleChanges) => {
  try {
    const response = await callAPI({
      method: RestApiMethod.POST,
      url: API_TEAM_PROJECT + API_ACTION.UPDATE + API_ACTION.BATCH,
      data: roleChanges
    });
    return response.data;
  } catch (error) {
    console.error('teamProjectApi updateTeamRoles error:', error.message);
    return false;
  }
};

const confirmRemoveTeamMembers = async (teamId, endDate, projectId, employeeId, teamRole, joinDate) => {
  try {
    const response = await callAPI({
      method: RestApiMethod.POST,
      url: API_TEAM_PROJECT + API_ACTION.UPDATE,
      data: {
        id: teamId,
        teamRole,
        joinDate,
        outDate: endDate,
        projectID: projectId,
        employeeID: employeeId,
      }
    });
    return response;     
  } catch (error) {
    console.error("Error deactivating team member:", error);
    return false;
  }
};

const teamProjectApi = {
  getProjectByEmployeeId,
  getCurrentTeamMembers,
  getTeamProjectMembersHistory,
  createTeamAssignments,
  updateTeamRoles,
  confirmRemoveTeamMembers,
  getEmployeeProjectsByPeriod,
};

export default teamProjectApi;